export default class DifficultyRating {
    static NOT_SET = {title: "Not Set", color: "gray"}
    static CHILL = {title: "Chill", color: "lightblue"}
    static EASY = {title: "Easy", color: "lightgreen"}
    static REGULAR = {title: "Regular", color: "yellow"}
    static HARD = {title: "Hard", color: "orange"}
    static EXTREME = {title: "Extreme", color: "red"}
    static INSANE = {title: "Insane", color: "purple"}

    static getDifficultyRating(difficulty: string) {
        switch (difficulty) {
            case "Chill":
                return DifficultyRating.CHILL
            case "Easy":
                return DifficultyRating.EASY
            case "Regular":
                return DifficultyRating.REGULAR
            case "Hard":
                return DifficultyRating.HARD
            case "Extreme":
                return DifficultyRating.EXTREME
            case "Insane":
                return DifficultyRating.INSANE
            default:
                return DifficultyRating.NOT_SET
        }
    }
}